<template>
  <div class="hello">
    <div class="text-left">
      <h1 class="mb-4">Import Your User Data</h1>
      <p>
        For instructions on how to upload your user data from your Student
        Information System (SIS):
        <a href="https://www.notion.so/Importing-Users-e3a57a54de6d49b4810eddee41f24d23" target="_blank" style="color: #157bff;">Click here.</a>
      </p>
    </div>
    <div class="upload">
      <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M68.4585 29.8755C67.2165 29.8755 66.0015 29.988 64.818 30.1815C61.866 20.529 52.722 13.5 41.8905 13.5C28.665 13.5 17.9505 23.976 17.9505 36.8955C17.9505 38.0475 18.0405 39.1815 18.207 40.2975C17.5665 40.2182 16.9219 40.1777 16.2765 40.176C7.2855 40.176 0 47.295 0 56.0835C0 64.872 7.2855 72 16.2765 72H36V54H24.75L45 31.5L65.25 54H54V72H68.4585C80.352 72 90 62.568 90 50.94C90 39.303 80.352 29.8755 68.4585 29.8755V29.8755Z"
          fill="#157BFF" />
      </svg>
      <div class="browse">
        <label class="add-photo-btn">Browse
          <span><input type="file" id="myfile" name="myfile" accept=".csv"
              @change="uploadFile($event)" /></span></label>
      </div>
      {{ selectedFileName }}
    </div>
    <div class="text-left mt-4">
      <button class="upload-btn btn btn-primary" @click="openPopupForCSV()">
        Upload Your Data
      </button>
    </div>

    <!-- <ImportCsvModal v-if="isModalCSVVisible" /> -->
    <div class="modal fade show" id="importmodal" v-if="isModalCSVVisible">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content px-3">
          <div class="modal-header pt-4 px-4 pb-0">
            <button type="button" @click="closePopupForCSv()" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="head">
            <h5 class="modal-title" id="exampleModalLabel">
              Match Your User Data
            </h5>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col">
                  <div class="form-group text-left">
                    <label for="exampleFormControlSelect1">First Name</label>
                    <select class="form-control" id="exampleFormControlSelect1" name="firstName" v-model="firstName">
                      <option v-for="item in header" :key="item">{{
                        item
                      }}</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group text-left">
                    <label for="exampleFormControlSelect1">Last Name</label>
                    <select class="form-control" id="exampleFormControlSelect1" name="lastName" v-model="lastName">
                      <option v-for="item in header" :key="item">{{
                        item
                      }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group text-left">
                    <label for="exampleFormControlSelect1">Email Address</label>
                    <select class="form-control" id="exampleFormControlSelect1" name="email" v-model="email">
                      <option v-for="item in header" :key="item">{{
                        item
                      }}</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group text-left">
                    <label for="exampleFormControlSelect1">Password</label>
                    <select class="form-control" id="exampleFormControlSelect1" name="password" v-model="password">
                      <option v-for="item in header" :key="item">{{
                        item
                      }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group level text-left">
                    <label for="exampleFormControlSelect1">Grade Level</label>
                    <select class="form-control" id="exampleFormControlSelect1" v-model="grade" name="grade">
                      <option v-for="item in header" :key="item">{{
                        item
                      }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="loadersmall" v-if="loading"></div>
            <button type="button" class="btn btn-primary" @click="submitForm()" v-if="!loading">
              Finalise Import
            </button>
            <button type="button" @click="closePopupForCSv()" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Component } from 'vue-property-decorator'
  import { namespace } from 'vuex-class'
  import BaseList from '@/components/BaseList'
  import ImportCsvModal from '@/components/common/ImportCsvModal'
  import { baseUrl } from '@/config'
  const appModule = namespace('app')
  const lessonsModule = namespace('lessons')

  @Component({
    components: {
      ImportCsvModal
    }
  })
  export default class ImportUsersCsv extends BaseList {
    @appModule.State('filterBySchool') stateFilterBySchool
    @appModule.State('schools') stateSchools
    @lessonsModule.State('statuses') stateStatuses
    loading = false
    data() {
      return {
        isModalVisible: false,
        isModalCSVVisible: false,
        header: '',
        originalHeader: ['firstName', 'lastName', 'email', 'password', 'grade'],
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        grade: '',
        selectedFileName: ''
      }
    }

    showModal() {
      this.isModalVisible = true
    }

    openPopupForCSV() {
      if (this.output && this.output.length > 0) {
        this.isModalCSVVisible = true
      } else {
        this.$swal({
          type: 'error',
          title: 'Please Choose your file!!'
        })
      }
    }

    closePopupForCSv() {
      this.isModalCSVVisible = false
    }

    closeModal() {
      this.isModalVisible = false
    }

    /**
     * Upload CSV
     */
    uploadFile(event) {
      let schoolId = localStorage.getItem('schoolId');
      if (schoolId) {
        if (event) event.preventDefault()
        var files = event.target.files[0]
        if (files != undefined) {
          this.selectedFileName = files.name
          var reader = new FileReader()
          let file = files
          reader.readAsText(file, 'UTF-8')
          reader.onload = evt => {
            this.fileinput = evt.target.result
            if (this.fileinput) {
              const lines = this.fileinput.split('\n')
              const header = lines[0].split(',')
              const output = lines.slice(1).map(line => {
                const fields = line.split(',')
                return Object.fromEntries(header.map((h, i) => [h, fields[i]]))
              })
              this.output = output
              this.header = header
            }
          }
        } else {
          this.$swal({
            type: 'error',
            title: 'Please Choose your file!!'
          })
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: 'Please first select a school from the top dropdown.'
        })
      }
    }

    /**
     *  Submit Form
     * */
    submitForm() {
      if (
        !this.firstName ||
        !this.lastName ||
        !this.email ||
        !this.password ||
        !this.grade
      ) {
        alert('Please select all fields')
      } else {
        let schoolId = localStorage.getItem('schoolId');
        this.loading = true
        let headers = [];
        for (let data of this.output) {
          Object.keys(data).forEach((key) => {
            var replacedKey = key.trim();
            if (key !== replacedKey) {
              data[replacedKey] = data[key];
              delete data[key];
            }
          });
          if (
            data[this.firstName] &&
            data[this.lastName] &&
            data[this.email] &&
            data[this.password] &&
            data[this.grade]
          ) {
            headers.push({
              firstName: data[this.firstName],
              lastName: data[this.lastName],
              email: data[this.email],
              password: data[this.password],
              grade: data[this.grade]
            })
          }
        }
        let formattedData = {
          data: headers,
          schoolId: schoolId
        }

        this.$http
          .post(`${baseUrl}users/save-users`, formattedData)
          .then(response => {
            headers = []
            if (response.data.success == true) {
              this.closePopupForCSv()
              this.$router.push('/students')
              this.loading = false
              this.$swal({
                type: 'success',
                title: 'Saved!!',
                text: response.data.message
              })
            } else {
              this.loading = false
              this.$swal({
                type: 'error',
                title: 'Oops...',
                text:
                  typeof response.data.message == 'object'
                    ? response.data.message.message
                    : response.data.message
              })
            }
          })
          .catch(response => {
            this.loading = false
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: response.data.message
            })
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loadersmall {
    border: 5px solid #f3f3f3;
    border-top-color: rgb(243, 243, 243);
    border-top-style: solid;
    border-top-width: 5px;
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
    border-top: 5px solid #555;
    border-radius: 50%;
    width: 50px;
    height: 50px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .upload {
    border: 1px solid #ccc;
    width: 50%;
    border-radius: 30px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .browse {
    width: 210px;
  }

  .browse input[type='file'] {
    z-index: 999;
    line-height: 0;
    font-size: 50px;
    position: absolute;
    opacity: 0;
    filter: alpha(opacity=0);
    -ms-filter: 'alpha(opacity=0)';
    cursor: pointer;
    _cursor: hand;
    margin: 0;
    padding: 0;
    left: 0;
  }

  .add-photo-btn {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    text-align: center;
    background-color: transparent;
    color: #157bff;
    display: block;
    width: 197px;
    height: 31px;
    font-size: 22px;
    line-height: 30px;
    float: left;
    text-decoration: underline;
  }

  .upload-btn {
    padding: 10px 30px;
  }

  .modal.show {
    background-color: #00000080;
    display: block;
  }

  .modal-header {
    border-bottom: none;
  }

  .level {
    width: 50% !important;
    display: flex;
    flex-direction: column;
    padding-right: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/students/ImportUsersCsv.vue